import { SensorData } from 'types'

export const isSteppedSensor = (data: SensorData | undefined): boolean =>
  data?.point_type === 'Digital' || data?.step === true || data?.step === 1

type DigitalPointData = SensorData & {
  digital_states?: Record<string, string>
}

export const digitalStateName = (
  data: DigitalPointData | undefined,
  value: number | null | undefined
): string | undefined =>
  value === null || value === undefined
    ? undefined
    : data?.digital_states?.[String(value)]

export const holdLastSampleToEnd = (
  column: (number | null | undefined)[]
): (number | null | undefined)[] => {
  const lastSample = column.findLast((value) => typeof value === 'number')
  if (lastSample === undefined || column.at(-1) === lastSample) return column
  return [...column.slice(0, -1), lastSample]
}
